import { render, staticRenderFns } from "./Expertthinktankdetails.vue?vue&type=template&id=926b25ae&scoped=true&"
import script from "./Expertthinktankdetails.vue?vue&type=script&lang=js&"
export * from "./Expertthinktankdetails.vue?vue&type=script&lang=js&"
import style0 from "./Expertthinktankdetails.vue?vue&type=style&index=0&id=926b25ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926b25ae",
  null
  
)

export default component.exports